const userGuide = {
  openGuide: 'Open the user guide',
  unavailable: 'The user guide is not available at the moment. Please try again later or write to <emailLink>{{email}}</emailLink>.',
};

export default userGuide;
